import React, { createContext, useState, useEffect } from "react";
import { showAlert } from "./Alerts";
import { APICall } from "./api";
import { CommonFunctions } from "./CommonFunctions";
import { setLogoutSession } from "../components/UserIdle";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(true);
  const { setUserCurrentRole } = CommonFunctions();

  const validateToken = async (url, payload = null) => {
    const authToken = btoa(
      `${process.env.REACT_APP_SERVER_LOGIN_USERNAME}:${process.env.REACT_APP_SERVER_LOGIN_PASSWORD}`
    );
    try {
      const response = await APICall(
        url,
        "POST",
        payload,
        {
          "Content-Type": "application/json",
          // Authorization: `Basic ${authToken}`,
        }
      );
      if (response) {
        localStorage.setItem("token", response.access_token);
        localStorage.setItem(
          "userInfo",
          JSON.stringify(response.UserRequest)
        );
        localStorage.setItem("user", response.UserRequest.name);
        localStorage.setItem("userMappedRoles", JSON.stringify(response.UserRequest.roles));
        // UserIdle reads this on mount to know how long the session has left.
        setLogoutSession();
        setUserCurrentRole(JSON.stringify(response.UserRequest.roles));
        setUser(response.UserRequest.name);
        setUserType(response.UserRequest.type);
        setLoading(false);
        return true;
      }
      else {
        return false;
      }
      // setLoading(false);
    } catch (error) {
      showAlert("Unauthorized", "Login Failed", "warning");
      setLoading(false);
      throw error;
    }
  };

  const logout = async () => {
    try {
      const response = await APICall(
        `${process.env.REACT_APP_SERVER_LOGIN_URL}_logout`,
        "POST",
        JSON.stringify({ "access_token": localStorage.getItem("token") }),
        {
          "Content-Type": "application/json",
        }
      );
      localStorage.clear();
      setUser(null);
    } catch (error) {
      showAlert("Unauthorized", "Login Failed", "warning");
      setLoading(false);
      throw error;
    }
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token !== 'undefined') {
      const userRequest = JSON.parse(localStorage.getItem("userInfo"));
      if (token && userRequest) {
        setUser(localStorage.getItem("user"));
        setUserType(userRequest.type);
      }
    }
    setLoading(false);
  }, []);

  const checkIsLoggedIn = async () => {
    try {
      const payload = {
        RequestInfo: {
          authToken: localStorage.getItem("token")
        }
      }
      if(localStorage.getItem("token")){
      const res = await APICall(
        `${process.env.REACT_APP_SERVER_BASE_URL}/user/_details?access_token=${localStorage.getItem("token")}`,
        "POST",
        JSON.stringify(payload),
        { "Content-Type": "application/json" }
      );
      return res;
    }

    } catch (error) {
      console.log(error);
      return {};
    }

  }

  return (
    <AuthContext.Provider value={{ user, userType, logout, validateToken, loading, checkIsLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
